/**
 * Points the admin to the Harnesses section when no harness exists yet — the
 * LLM Profile form has nothing to select and cannot be submitted (spec 240
 * FR-008).
 *
 * A same-page anchor rather than a route Link: the Harnesses section lives on
 * this same combined page, so navigating away would be wrong.
 */
export function NoHarnessesEmptyState() {
  return (
    <p className="text-muted-foreground text-sm">
      No harnesses exist yet.{' '}
      <a href="#harnesses-section" className="text-foreground underline">
        Create one
      </a>{' '}
      before adding an LLM Profile.
    </p>
  );
}
